import request from '@/utils/axios.js'

// app端 判断是否已领取
export function haveCoupon (data) {
  return request({
    url: '/manageMarket/mobileAPI/coupons/check/user/coupons',
    method: 'post',
    data: data
  })
}

// 劵领取
export function getCoupon (data) {
  return request({
    url: '/manageMarket/mobileAPI/coupons/grant',
    method: 'post',
    data: data
  })
}

// 获取任务链接
export function getTaskUrl (appId) {
  return request({
    url: `/manageApp/mobileAPI/app/detail?appId=${appId}`,
    method: 'get'
  })
}
